module.exports = __webpack_public_path__ + "img/10.45f34757.jpg";